import { render, staticRenderFns } from "./EventsDownload.vue?vue&type=template&id=06b5795c&"
import script from "./EventsDownload.vue?vue&type=script&lang=js&"
export * from "./EventsDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports